export default __webpack_public_path__ + "static/media/Glass-wool-Insulation.6ccbb6e8.jpg";